import { render } from "./AddSupplierGroup.vue?vue&type=template&id=2e70a1af"
import script from "./AddSupplierGroup.vue?vue&type=script&lang=js"
export * from "./AddSupplierGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__